import React from "react";

import Zendesk from "react-zendesk";

const AppZendesk: React.FC = () => {
  const ZENDESK_KEY = process.env.ZENDESK_KEY;
  return <Zendesk defer zendeskKey={ZENDESK_KEY} />;
};
export default React.memo(AppZendesk);
